import { render, staticRenderFns } from "./Hangman.vue?vue&type=template&id=1c851cba&"
import script from "./Hangman.vue?vue&type=script&lang=js&"
export * from "./Hangman.vue?vue&type=script&lang=js&"
import style0 from "./Hangman.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports